import { render, staticRenderFns } from "./AutoLogin.vue?vue&type=template&id=2640fd18&scoped=true"
import script from "./AutoLogin.vue?vue&type=script&lang=js"
export * from "./AutoLogin.vue?vue&type=script&lang=js"
import style0 from "./AutoLogin.vue?vue&type=style&index=0&id=2640fd18&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2640fd18",
  null
  
)

export default component.exports